
  <div class="reward--scale-container">
   <span class="hide-text-screenreader-only">Start of Risk Scale. On a scale of 1 to 5, 1 is less risk less reward, 5 is more risk more reward</span>
    <div class="reward--scale">
        <div *ngIf="data?.riskCode ===1;else mspace" [ngClass]="{'reward--scale__item--active1': data?.riskCode ===1}" class="reward--scale__item" data-rpa-tag-id="risk">
          <span class="hide-text-screenreader-only"> The fund risk level is a</span>
          {{ data.riskCode }}
        </div>
        <div *ngIf="data?.riskCode ===2;else mspace"  [ngClass]="{'reward--scale__item--active2': data?.riskCode ===2}" class="reward--scale__item" data-rpa-tag-id="risk">
          <span class="hide-text-screenreader-only">The fund risk level is a</span>
          {{ data.riskCode }}
        </div>
        <div *ngIf="data?.riskCode ===3;else mspace" [ngClass]="{'reward--scale__item--active3': data?.riskCode ===3}" class="reward--scale__item" data-rpa-tag-id="risk">
          <span class="hide-text-screenreader-only">The fund risk level is a</span>
          {{ data.riskCode }}
        </div>
        <div *ngIf="data?.riskCode ===4;else mspace" [ngClass]="{'reward--scale__item--active4': data?.riskCode ===4}"  class="reward--scale__item " data-rpa-tag-id="risk">
          <span class="hide-text-screenreader-only">The fund risk level is a</span>
          {{ data.riskCode }}
        </div>
        <div *ngIf="data?.riskCode ===5;else mspace" [ngClass]="{'reward--scale__item--active5': data?.riskCode ===5}" class="reward--scale__item" data-rpa-tag-id="risk">
          <span class="hide-text-screenreader-only">The fund risk level is a</span>
          {{ data.riskCode }}
        </div>
          <ng-template #mspace><div class="reward--scale__item"></div></ng-template>

    </div>
    <div class="risk-less-more">
        <p class="less">Less</p>
        <p class="more">More</p>
    </div>
    <span class="hide-text-screenreader-only">End of Risk Scale.</span>
  </div>
